import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { AssetsLiabilitiesSection } from '../components/AssetsLiabilitiesSection';
import { CurrencyToggle } from '../components/CurrencyToggle';
import { usePortfolioPrefsStore } from '../store';

// Group-scope A&L: the same component the Entities and Personal scopes use,
// pointed at scope=group -- every business entity PLUS every personal entity
// on one balance sheet. This is what makes personally-held property (Vertus
// Suite and its BNP mortgage) visible next to the company-held ones instead
// of only on the Personal sheet.
//
// It is an AGGREGATE, not a consolidation: intra-group balances are not
// eliminated, exactly as the "All Entities" and "All Personal" aggregates
// behave today. Manual items cannot be filed against it (they always belong
// to a real scope), so the section renders read-only.

export function GroupAssetsLiabilitiesPage() {
  const displayCurrency = usePortfolioPrefsStore((s) => s.displayCurrency);

  return (
    <DashboardLayout>
      <div className="space-y-6 p-4 md:p-6" data-testid="group-assets-liabilities-page">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Assets &amp; Liabilities</h1>
            <p className="text-sm text-muted-foreground">
              Group (all entities + personal, aggregate)
            </p>
          </div>
          <CurrencyToggle />
        </div>

        <AssetsLiabilitiesSection scope="group" displayCurrency={displayCurrency} />
      </div>
    </DashboardLayout>
  );
}
